import React from 'react';
import PageHeader from './PageHeader';

const ideas = [
  {
    status: 'planned',
    priority: 'Dashboard: pewność statusu mieszkania',
    title: 'Status mieszkania: 3 jawne stany zamiast „gość Jacek” przed check-inem',
    source: 'Zgłoszenie Michała 2026-06-03: dashboard mówił „gość”, gdy gość dopiero miał przyjechać tego dnia.',
    context: [
      'Dashboard pokazuje teraz ogólny status typu „gość w mieszkaniu” / „puste”.',
      'Przy rezerwacji z check-inem dzisiaj status może wprowadzać w błąd — gość jeszcze nie dojechał.',
      'Maria i Michał potrzebują jednoznacznej odpowiedzi: czy mieszkanie jest gotowe, czy nie, czy ktoś w nim jest, czy nie.'
    ],
    goal: 'Trzy stany: „Puste, posprzątane, gotowe” (zielono), „Puste, ale nie posprzątane” (żółto), „Gość w mieszkaniu” (niebieski).',
    examples: [
      'Puste + gotowe → zielono + „Gotowe na gości”.',
      'Puste + brak checklisty po checkoucie → żółto + „Do posprzątania”.',
      'Gość w mieszkaniu (teraz pomiędzy check-in a check-out) → niebiesko + „Gość w mieszkaniu”.',
      'Rezerwacja z check-inem dzisiaj, ale jeszcze nie dojechał → traktujemy jak „Puste, posprzątane, gotowe”.'
    ],
    questions: [
      'Czy mieszkanie „Puste, posprzątane, gotowe” ma wymagać potwierdzenia z WhatsApp od Marii, czy wystarczy checklista cleaning_job zakończona?',
      'Czy dodać ręczny override dla Michała („wymuś gotowe”) na wypadek awarii?',
      'Czy status „Gość w mieszkaniu” ma pojawiać się dopiero od godziny check-in, czy od północy dnia check-in?',
      'Czy 3 stany mają też trafić do statusu „WhatsApp” obok potwierdzenia gotowości?'
    ]
  },
  {
    status: 'planned',
    priority: 'Research: jakość gościa (NUKI gotowe)',
    title: 'Self check-in przez NUKI: automatyczny kod na czas pobytu',
    source: 'Research rynku najmu krótkoterminowego + fakt: mamy NUKI Smart Lock, 2026-06-03.',
    context: [
      'NUKI Smart Lock ma otwarte API (NUKI Web API, darmowe dla właścicieli) i pozwala wysłać gościowi jednorazowy kod naboru na konkretne godziny.',
      'Większość obecnych właścicieli 1 apartamentu używa NUKI + skrytki na klucz lub kodu PIN wysyłanego ręcznie.',
      'Konkurencja dla 1 mieszkania: igloohome Smart Keybox 3 (~600-700 PLN jednorazowo, brak API, kod stały wpisywany ręcznie), Yale Linus (~700 PLN + Connect WiFi bridge ~200 PLN, API).',
      'Najtańsza sensowna opcja dla 1 mieszkania w PL: NUKI Combo (Smart Lock 4.0 + Bridge) ~1100-1300 PLN jednorazowo, brak opłat miesięcznych, API w NUKI Web (darmowe po stronie właściciela).',
      'Dla 1 mieszkania SaaS channel manager (Hospitable, Guesty, Hostaway) ma cenę 20-50 USD/mies — w naszym kontekście overkill.'
    ],
    goal: 'Portal generuje jednorazowy PIN do NUKI z zakresu dat check-in / check-out, wysyła go gościowi w wiadomości przed przyjazdem.',
    questions: [
      'Czy mamy już NUKI Bridge (do zdalnego API) czy tylko Smart Lock bez Bridge? Bez Bridge nie da się zdalnie zmieniać kodu.',
      'Czy portal ma tylko wygenerować PIN i pokazać Tobie do ręcznego wysłania, czy od razu wysłać gościowi przez Booking?',
      'Czy chcesz opcję awaryjną: kod stały na wypadek awarii NUKI / braku WiFi?',
      'Czy kod ma być unikalny per rezerwacja (bezpieczniej) czy stały dla stałych gości (prościej)?'
    ]
  },
  {
    status: 'planned',
    priority: 'Research: przychód (PriceLabs / Beyond)',
    title: 'Rekomendacje cen dynamicznych dla 1 apartamentu',
    source: 'Research rynku najmu krótkoterminowego, 2026-06-03. PriceLabs.com, Beyond Pricing, Wheelhouse.',
    context: [
      'PriceLabs (lider rynku): ma plan "Starter" do 2 mieszkań — ok. 20-25 USD/mies. Integracja z Booking.com, kalendarz wydarzeń, sugestie cen na 365 dni. Realnie używany przez >50% małych właścicieli w PL.',
      'Beyond Pricing: droższe, ~50-100 USD/mies, ale bardziej zautomatyzowane i ma wsparcie PL/PLN.',
      'Wheelhouse: ~30 USD/mies, dobre dla 1-2 mieszkań, integracja z Booking.',
      'Alternatywa: rekomendacje cen we własnym portalu (model IDEAS v0.7) — bez opłat miesięcznych, ale wymaga własnej bazy cen i integracji z kompetycją.',
      'Dla 1 apartamentu najczęściej wystarcza PriceLabs Starter. Bez integracji dynamicznych cen, sam portal i tak może liczyć rekomendacje.'
    ],
    goal: 'Codziennie portal pobiera rekomendacje cen z PriceLabs API (lub liczy własne na bazie obłożenia) i pokazuje je jako „podnieś o 30 zł”, „daj rabat na weekend”.',
    questions: [
      'Czy chcesz płacić 20-25 USD/mies za PriceLabs, czy wolisz własny moduł rekomendacji w portalu?',
      'Czy portal ma tylko rekomendować (widok dla admina), czy automatycznie aktualizować ceny w Booking.com?',
      'Jaki masz targetowy ADR (średnia cena/noc) i minimalną dopuszczalną cenę?',
      'Czy chcesz reguły last-minute (np. 7 dni przed: -15%) i minimum stay (np. w weekend 2 noce)?'
    ]
  },
  {
    status: 'planned',
    priority: 'Research: opinie i reputacja',
    title: 'Automatyczna prośba o opinię + alarm niskiej oceny',
    source: 'Research rynku najmu krótkoterminowego, 2026-06-03. Booking.com ma wbudowaną opcję; Hospitable, Lodgify.',
    context: [
      'Booking.com ma wbudowaną opcję „Prośby o opinie” — można ją włączyć w ustawieniach opinii gości (Settings > Guest reviews > Review request schedule). Bez dodatkowych kosztów.',
      'Hospitable.com (wcześniej Smartbnb): od ~20 USD/mies, automatycznie wysyła prośby o opinie przez Booking/Airbnb i ma alerty na niską ocenę.',
      'Dla 1 mieszkania najprostsze: włączyć wbudowaną opcję Booking.com + dodać w portalu wewnętrzny formularz „zostaw notatkę” dla gościa jako backup.',
      'Lodgify: od ~16 USD/mies, ma wbudowane review requests, ale głównie dla właścicieli z własną stroną www.',
      'Niska ocena (np. <7/10) powinna tworzyć zadanie naprawcze w portalu zamiast ginąć poza portalem.',
    ],
    goal: 'Włączyć Booking.com review requests, plus w portalu wewnętrzny zapis recenzji + automatyczne zadanie dla admina przy ocenie <7/10.',
    questions: [
      'Czy chcesz powielać opinie z Booking.com do portalu (ręcznie, półautomatycznie z emaila), czy tylko patrzeć na nie w Booking?',
      'Czy zadanie „niska ocena” ma iść do Ciebie bezpośrednio, czy do agenta na WhatsApp?',
      'Czy dodać prosty formularz „zostaw notatkę” dla gościa po wymeldowaniu, niezależny od Booking.com?',
      'Jaki próg alarmu (np. <7/10 tworzy zadanie, <5/10 idzie pilne)?'
    ]
  },
  {
    status: 'done',
    priority: 'Zrealizowane teraz',
    title: 'Per-page <title> per route',
    source: 'Zgłoszenie 2026-06-02, podczas audytu UX.',
    context: [
      'Każda podstrona miała wcześniej ten sam tytuł: Hermes Rental Portal.',
      'Utrudniało to historię przeglądarki i pracę na wielu kartach.',
      'Zmiana jest mała, bezpieczna i poprawia codzienne używanie portalu.'
    ],
    goal: 'Każda podstrona ma tytuł odzwierciedlający zawartość.',
    examples: [
      '/login → Logowanie · Hermes Rental Portal',
      '/dashboard → Start · Hermes Rental Portal',
      '/rezerwacje → Rezerwacje · Hermes Rental Portal',
      '/sprzatanie/123 → Sprzątanie #123 · Hermes Rental Portal',
      '/zakupy → Zakupy i zwroty · Hermes Rental Portal',
      '/pomysly → Pomysły do launchu · Hermes Rental Portal'
    ],
    done: [
      'Dodany komponent PageTitle w routerze React.',
      'Tytuł zmienia się automatycznie przy przejściu między route’ami.',
      'Nie wymaga dodatkowej biblioteki typu Helmet.'
    ],
    questions: []
  },

  {
    status: 'next',
    priority: 'Research: komunikacja i jakość gościa',
    title: 'Automatyczne wiadomości przed przyjazdem i self check-in',
    source: 'Research rynku najmu krótkoterminowego, 2026-06-03.',
    context: [
      'Goście oczekują szybkiej odpowiedzi i jasnych instrukcji bezkontaktowego check-in.',
      'Dobra responsywność i kompletne instrukcje zmniejszają liczbę pytań w dniu przyjazdu.',
      'Portal ma już dane rezerwacji, godzinę check-in i docelowo wiadomości z Booking.'
    ],
    goal: 'Szablony wiadomości: po rezerwacji, 24h przed przyjazdem i w dniu check-in — dojazd, NUKI/skrytka, Wi‑Fi, zasady pobytu.',
    questions: [
      'Potwierdzić finalną treść instrukcji check-in i dane Wi‑Fi.',
      'Zdecydować, czy wysyłać przez telefon / Pulse, email czy WhatsApp.',
      'Dodać zabezpieczenie: bez wysyłki jeśli agent nie ma pewnego kodu/danych.'
    ]
  },
  {
    status: 'planned',
    priority: 'Research: przychód',
    title: 'Reguły dynamicznych cen i luk w kalendarzu',
    source: 'Research rynku najmu krótkoterminowego, 2026-06-03.',
    context: [
      'Stała cena nie reaguje na weekendy, święta, wydarzenia lokalne i popyt last minute.',
      'Revenue management w krótkim najmie polega na automatycznej korekcie cen i minimalnej długości pobytu.',
      'Portal widzi obłożenie i może wyliczać rekomendacje nawet bez automatycznego zapisu do Booking.'
    ],
    goal: 'Codzienna karta rekomendacji: podnieść/obniżyć cenę, zamknąć lukę jedną nocą, podnieść weekendy, dać rabat na bliski pusty termin.',
    questions: [
      'Czy portal ma tylko rekomendować ceny, czy docelowo zmieniać je w Booking?',
      'Ustalić minimalną/maksymalną cenę i reguły sezonu.',
      'Dodać kalendarz wydarzeń Szczecina jako sygnał cenowy.'
    ]
  },
  {
    status: 'planned',
    priority: 'Research: opinie',
    title: 'Automatyczna prośba o opinię i alarm niskiej oceny',
    source: 'Research rynku najmu krótkoterminowego, 2026-06-03.',
    context: [
      'Aktualne, dobre opinie mocno wpływają na konwersję i zaufanie gości.',
      'Po checkout można wysłać krótkie podziękowanie i prośbę o ocenę.',
      'Niska opinia lub skarga powinna tworzyć zadanie naprawcze, a nie znikać w panelu Booking.'
    ],
    goal: 'Po wymeldowaniu automatycznie wysłać podziękowanie; przy problemie lub niskiej ocenie utworzyć zadanie dla admina z rekomendacją odpowiedzi.',
    questions: [
      'Ustalić ton wiadomości po pobycie.',
      'Dodać import opinii z Booking.com.',
      'Zdefiniować próg alarmu, np. ocena poniżej 8/10.'
    ]
  },
  {
    status: 'planned',
    priority: 'Admin: operacje sprzątania',
    title: 'Admin: historia i statystyki sprzątań bez listy przyszłych terminów',
    source: 'Prośba Michała o przemyślenie strony sprzątania dla adminów, 2026-06-03.',
    context: [
      'Portal obsługuje jedno mieszkanie, więc widok nie powinien udawać hotelowego grafiku wielu pokoi.',
      'W praktyce istnieje tylko jedno istotne przyszłe sprzątanie: następne po najbliższym checkout.',
      'Dla admina większą wartość ma historia, kontrola jakości, opóźnienia i rozliczenie Marii niż długa lista przyszłych terminów.'
    ],
    goal: 'Przebudować /sprzatanie dla admina na: małą kartę „Następne sprzątanie”, statystyki operacyjne i historię poprzednich sprzątań z filtrami.',
    questions: [
      'Statystyki: sprzątania w miesiącu, zakończone/opóźnione, średni czas od checkout do zakończenia, nierozliczone płatności, najczęstsze braki z checklisty.',
      'Historia: rezerwacja, checkout, kto sprzątał, start/koniec, status checklisty, płatność, notatki/problemy.',
      'Nie pokazywać listy przyszłych sprzątań; najwyżej jedna karta „Następne sprzątanie”.',
      'Potwierdzić zakres historii: tylko zakończone czy również anulowane/problematyczne wpisy.'
    ]
  },
  {
    status: 'next',
    priority: 'P0 przed publicznym launchem',
    title: 'QNAP jako publiczny reverse proxy / edge load balancer',
    source: 'Deep research load balancera dla portalu z wykorzystaniem QNAP, 2026-06-03.',
    context: [
      'Na start load balancer powinien oznaczać edge reverse proxy z TLS, nie wiele replik backendu.',
      'Przy FastAPI + SQLite + jednym backendzie proxy daje domenę, HTTPS, routing, logi i health-checki, ale nie daje prawdziwego HA.',
      'QNAP ma publiczne IP 91.233.137.30; trwałe dane/certyfikaty/logi trzymać pod /share/CACHEDEV1_DATA, nigdy pod /mnt/sdb.',
      'Port 8080 na QNAP jest zajęty przez QTS/fcgi; publicznie używać 80/443, techniczne panele tylko LAN/VPN albo 18080+.'
    ],
    goal: 'Wystawić portal przez domenę HTTPS na QNAP, rekomendowanym narzędziem Caddy: / -> frontend, /api/ -> backend, z trwałym storage certyfikatów i testem tras React Router.',
    questions: [
      'Rekomendacja: Caddy. Nginx Proxy Manager tylko jeśli potrzebny jest panel UI; Traefik dopiero przy wielu usługach; HAProxy to overkill; QNAP built-in Reverse Proxy tylko testowo/LAN.',
      'Wykonane: frontend używa relatywnego /api w produkcji; port backendu jest używany tylko dla vite dev na localhost/LAN.',
      'Nie skalować backendu na kilka replik, dopóki baza to SQLite; prawdziwe HA wymaga PostgreSQL + osobnego storage dla uploadów.',
      'Test akceptacyjny: HTTPS działa, odświeżenie /dashboard /sprzatanie /rezerwacje/<ref> nie daje 404, login działa przez /api/login bez portu 8000, /api/health działa przez domenę.'
    ]
  },
  {
    status: 'next',
    priority: 'Następne sensowne',
    title: 'Automatyczny WhatsApp do Marii przy „Do doprecyzowania”',
    source: 'Dyskusja o weryfikacji zakupów Marii, 2026-06-02.',
    context: [
      'Maria dodaje zakup + paragon.',
      'Backend nadaje recenzję: ok / needs_clarification / ai_pending.',
      'Worker AI sprawdza zdjęcie paragonu modelem vision.',
      'Jeśli wynik to needs_clarification, status jest dziś widoczny tylko w portalu.'
    ],
    goal: 'Wysłać Marii automatyczną wiadomość WhatsApp, gdy zakup przejdzie w needs_clarification, z krótkim pytaniem doprecyzowującym.',
    questions: [
      'Potwierdzić numer/kontakt Marii w WhatsApp Web.',
      'Dodać zabezpieczenie przed wielokrotną wysyłką dla tego samego zakupu.',
      'Zapisać w bazie notified_at / notification_channel / notification_error.',
      'Dodać prosty log dla admina: wysłano / błąd / pominięto.'
    ]
  },
  {
    status: 'planned',
    priority: 'Do rozważenia po launchu',
    title: 'Widok pomysłów jako mini-roadmapa zamiast statycznej listy',
    source: 'Przegląd strony /pomysly, 2026-06-02.',
    context: [
      'Strona była tylko listą tekstową dwóch tematów.',
      'Nie było jasne, co jest już zrobione, co jest następne, a co wymaga decyzji.',
      'Admin powinien jednym spojrzeniem widzieć: zrealizowane / następne / zaparkowane.'
    ],
    goal: 'Utrzymać tę stronę jako mały panel decyzyjny dla publicznego launchu.',
    questions: [
      'Czy pomysły mają być edytowalne z UI, czy wystarczy repozytorium?',
      'Czy dodawać statusy typu koszt / ryzyko / wpływ na Marię?',
      'Czy po realizacji automatycznie przenosić wpis do changeloga?'
    ]
  },
  {
    status: 'done',
    priority: 'P0 naprawione w audycie 2026-06-09',
    title: 'Klasyfikacja automatycznych wiadomości Booking.com',
    source: 'Audyt 2026-06-09: 49/53 (92%) wiadomości miało category="unknown" — w większości automaty Booking.com ("Spodziewamy się Państwa...", "Dzień Państwa zameldowania to...").',
    context: [
      'Wiadomości automatyczne (Booking.com conversation, Automatyczna wiadomość apartamentu, puste placeholdery) zaśmiecały kolejkę admina.',
      'Powodowały fałszywe alarmy "needs_human_review" dla treści, na które nie trzeba odpowiadać.',
      'Nowa kategoria "automatic_message" pozwala je zarchiwizować bez eskalacji.'
    ],
    goal: 'Klasyfikator rozpoznaje automaty Booking.com i puste placeholdery i nadaje im category="automatic_message" z priority=5, bez akcji.',
    done: [
      'Dodana kategoria "automatic_message" w backend/app/guest_messages.py.',
      'Heurystyka: nadawca zawiera "Booking.com conversation" / "Automatyczna wiadomość" / "Gość lub ręczna wiadomość" → automat.',
      'Heurystyka: ciało zawiera "Spodziewamy się Państwa" / "Dzień Państwa zameldowania" / "Brak wiadomości" → automat.',
      'Heurystyka: puste ciało → automat.',
      'Skrypt scripts/reclassify_guest_messages.py zrobił retrowstywną reklasyfikację 49 unknown.',
      'Wynik: 34 → automatic_message, +1 billing_request (Emil Storonowicz), +3 thanks_no_action, 8 nadal unknown (treści bez sygnałów).'
    ],
    questions: [
      'Czy dodać więcej słów kluczowych (np. "Spodziewamy się Państwa" vs "Zapraszamy") w miarę napływu nowych wzorców?',
      'Czy 8 wiadomości niezaklasyfikowanych wymaga ręcznej analizy (np. "Jacek Cybruch / odkurzacz" → property_question)?'
    ]
  },
  {
    status: 'done',
    priority: 'P0 naprawione w audycie 2026-06-09',
    title: 'Ręczne potwierdzanie zapłaty za sprzątanie (admin/Monika)',
    source: 'Audyt 2026-06-09: 3 sprzątania zakończone z payment_status="unpaid" → 800 PLN dla Marii niepotwierdzone.',
    context: [
      'Endpoint PATCH /api/cleaning-jobs/{id}/payment już istniał w backendzie (admin-only), ale nie był odsłonięty w UI.',
      'Operator (Michał lub Monika) nie miał wygodnego sposobu potwierdzenia przelewu dla Marii.',
      'Wymagało to ręcznego UPDATE w bazie lub osobnej konsoli SQL.'
    ],
    goal: 'W widoku sprzątania admina panel „Rozliczenie z Marią" z kwotą, statusem, datą zapłaty, nazwiskiem potwierdzającego i przyciskiem „Potwierdź zapłatę".',
    done: [
      'Nowy panel w Cleaning.jsx (admin-side-panel) z .payment-summary, .payment-pill (paid/unpaid) i przyciskiem .payment-confirm-btn.',
      'Endpoint PATCH /api/cleaning-jobs/{id}/payment rozszerzony o payment_paid_by_name (JOIN z users).',
      'Lista /api/cleaning-jobs rozszerzona o payment_paid_by_name.',
      'Test integracyjny: 3 historyczne + 1 nowa transakcja (job 3, 100 PLN, Michał, 2026-06-10 07:40) — wszystko widoczne w API.',
      'Toast z potwierdzeniem po kliknięciu i obsługa błędu (rollback UI).'
    ],
    questions: [
      'Czy w przyszłości dodać cofnięcie zapłaty (unpay) w razie pomyłki?',
      'Czy eksportować miesięczne podsumowanie zapłat dla Marii (CSV/PDF)?'
    ]
  },
  {
    status: 'next',
    priority: 'Następne sensowne po P0',
    title: 'Czyszczenie śmieciowych danych w guest_messages',
    source: 'Audyt 2026-06-09: 2 wiadomości z datą 2031-10-01 (fałszywe testy), 1 wpis "Test Dedup" (syntetyczny), 2 billing_request bez booking_id (Bartosz Rogiński + Emil Storonowicz).',
    context: [
      'Daty 2031 w production wpływają na sortowanie "nowe" i raporty "świeżości".',
      'Wpis "Test Dedup" (id=1168) powinien być usunięty lub oznaczony jako testowy.',
      'Orphan billing_request psują mapowanie wiadomość → rezerwacja w portalu.'
    ],
    goal: 'Skrypt scripts/cleanup_guest_messages.py: usuń wpisy testowe/datowane 2031, oznacz orphan billing_request do ręcznej korekty, raportuj zmiany do decyzji Michała.',
    questions: [
      'Czy usuwać twardo, czy najpierw oznaczyć jako hidden=true (zachować audit trail)?',
      'Czy skrypt ma działać automatycznie (cron) czy ręcznie?',
      'Czy wiadomości sprzed 90 dni (poza payment_request) mają być archiwizowane automatycznie?'
    ]
  },
  {
    status: 'planned',
    priority: 'Roadmap Q3 2026 — publiczny launch',
    title: 'QNAP reverse proxy + Caddy dla HTTPS (portal.antoniak.cc)',
    source: 'Plan publicznego launchu, 2026-06-03, zaktualizowany w roadmapie Q3.',
    context: [
      'Mamy domenę portal.antoniak.cc, publiczny IP 91.233.137.30, QNAP w sieci domowej.',
      'Brak HTTPS = brak możliwości wysyłania linków gościom (WhatsApp, email) bez ostrzeżeń bezpieczeństwa.',
      'QNAP ma Caddy w kontenerze docker — gotowy do reverse proxy.'
    ],
    goal: 'Wdrożyć Caddy: 80/443 → frontend (3010) + /api/ → backend (8000), certyfikaty Let’s Encrypt, trwałe logi pod /share/CACHEDEV1_DATA.',
    questions: [
      'Czy przed wystawieniem HTTPS przejść na relatywne /api/ w frontend (usunąć twardy adres LAN backendu)?',
      'Czy dodać fail2ban lub rate-limit na /api/login w publicznym Caddy?',
      'Czy NUKI kod ma być wysyłany przez portal po HTTPS, czy zostaje ręczny WhatsApp?'
    ]
  },
  {
    status: 'planned',
    priority: 'Roadmap Q3 2026 — przychody',
    title: 'Moduł rekomendacji cenowych (lokalny, bez opłat SaaS)',
    source: 'Revenue plan 2026, część 1: pricing.',
    context: [
      'Mamy 1 apartament w Szczecinie, brak channel managera.',
      'Cena stała powoduje luki w kalendarzu i utracony przychód w szczycie sezonu.',
      'PriceLabs (20-25 USD/mies) i Beyond Pricing (50-100 USD/mies) to opcje zewnętrzne.'
    ],
    goal: 'Wewnętrzny moduł w portalu: dzienna rekomendacja ceny na bazie obłożenia, sezonu i dnia tygodnia. Rekomendacja widoczna dla admina, ale nie zmienia automatycznie ceny w Booking.',
    questions: [
      'Czy docelowo integracja z Booking.com API (wymaga partner agreement), czy tylko rekomendacje?',
      'Czy dodać kalendarz wydarzeń Szczecina (koncerty, mecze) jako sygnał cenowy?',
      'Czy reguły last-minute (np. -15% na 7 dni przed pustym terminem) mają być automatyczne, czy za potwierdzeniem admina?'
    ]
  },
  {
    status: 'planned',
    priority: 'Roadmap Q4 2026 — operacje',
    title: 'Automatyczny WhatsApp do Marii przy needs_clarification',
    source: 'Pomysł z PORTAL_TODO.md + 2026-06-02 dyskusja o weryfikacji zakupów.',
    context: [
      'Maria dodaje zakup + paragon.',
      'Backend nadaje recenzję: ok / needs_clarification / ai_pending.',
      'Dziś status needs_clarification jest widoczny tylko w portalu — Maria może nie zauważyć na czas.'
    ],
    goal: 'Wysyłać Marii WhatsApp przy needs_clarification z pytaniem doprecyzowującym; zabezpieczenie anti-dup; log wysyłek w DB.',
    questions: [
      'Numer WhatsApp Marii już potwierdzony (Selenium) czy wymaga ponownej weryfikacji?',
      'Czy wiadomość ma zawierać zdjęcie paragonu, czy tylko opis?',
      'Czy admin dostaje kopię tej wiadomości na swój WhatsApp?'
    ]
  },
  {
    status: 'planned',
    priority: 'Roadmap Q4 2026 — przychody',
    title: 'Import opinii z Booking.com + alarm niskiej oceny',
    source: 'Revenue plan 2026, część 2: reputacja.',
    context: [
      'Niska ocena (<7/10) tworzy dziś zagrożenie dla pozycji w wynikach Booking, ale informacja ginie poza portalem.',
      'Booking.com ma wbudowane review requests (bezpłatne) — wystarczy włączyć.',
      'Recenzje w portalu dają nam historyczną analizę i dźwignię do poprawy.'
    ],
    goal: 'Cotygodniowy import opinii z Booking.com do tabeli reviews; próg <8/10 tworzy zadanie w portalu z rekomendacją odpowiedzi.',
    questions: [
      'Czy robić tymczasowy import ręczny, czy poczekać na Booking Connectivity APIs?',
      'Czy zadanie "niska ocena" idzie do Michała czy do agenta?',
      'Czy dodać własny formularz "zostaw notatkę" dla gościa jako backup niezależny od Booking?'
    ]
  },
  {
    status: 'planned',
    priority: 'Roadmap Q4 2026 — operacje',
    title: 'NUKI Smart Lock: automatyczny kod jednorazowy na pobyt',
    source: 'Research rynku, 2026-06-03 + fakt: mamy NUKI Smart Lock, brak integracji w portalu.',
    context: [
      'Gość oczekuje instrukcji check-in 24h przed przyjazdem.',
      'Dziś wysyłamy kod NUKI ręcznie.',
      'NUKI Web API (darmowe) pozwala generować jednorazowe kody z datą ważności.'
    ],
    goal: 'Portal generuje jednorazowy PIN do NUKI z zakresu check-in/check-out dla rezerwacji, wysyła gościowi w wiadomości (lub pokazuje adminowi do ręcznego wysłania).',
    questions: [
      'Czy mamy NUKI Bridge (wymagany do API) czy tylko Smart Lock bez Bridge?',
      'Czy portal ma wysyłać kod automatycznie przez telefon / Pulse, czy dawać adminowi do ręcznego wysłania?',
      'Czy awaryjny kod stały na wypadek awarii NUKI / Wi-Fi?'
    ]
  }
];

function statusLabel(status) {
  if (status === 'done') return '✓ Zrealizowane';
  if (status === 'next') return 'Następne';
  return 'Pomysł';
}

export default function PortalTodo() {
  const doneCount = ideas.filter(i => i.status === 'done').length;
  const nextCount = ideas.filter(i => i.status === 'next').length;
  const waitingCount = ideas.filter(i => i.status !== 'done' && i.status !== 'next').length;

  return (
    <section>
      <PageHeader
        icon="💡"
        title="Pomysły do publicznego launchu"
        description="Mini-roadmapa pomysłów do launchu i dalszego rozwoju portalu."
        helpKey="portal-todo"
        stats={[
          { label: 'Zrealizowane', value: doneCount, tone: 'success' },
          { label: 'Następne', value: nextCount, tone: 'warning' },
          { label: 'Parking', value: waitingCount, tone: 'info' }
        ]}
      />

      <article className="card todo-summary-card">
        <div>
          <span className="todo-kicker">Decyzja z tego przeglądu</span>
          <h2>Zrealizowałem mały, bezpieczny punkt: tytuły stron per route.</h2>
          <p className="muted">WhatsApp do Marii zostaje jako następna większa rzecz, bo wymaga trwałego logu wysyłek i ochrony przed duplikatami.</p>
        </div>
      </article>

      <div className="todo-ideas">
        {ideas.map((idea, idx) => (
          <article className={`card todo-idea ${idea.status}`} key={idea.title}>
            <div className="idea-index">#{idx + 1}</div>
            <div>
              <div className="idea-title-row">
                <div>
                  <span className={`idea-status ${idea.status}`}>{statusLabel(idea.status)}</span>
                  <span className="idea-priority">{idea.priority}</span>
                </div>
                <h2>{idea.title}</h2>
              </div>
              <p className="muted"><strong>Źródło:</strong> {idea.source}</p>
              <h3>Kontekst</h3>
              <ul>{idea.context.map(item => <li key={item}>{item}</li>)}</ul>
              <h3>Cel</h3>
              <p>{idea.goal}</p>
              {idea.examples && (
                <>
                  <h3>Przykłady</h3>
                  <ul>{idea.examples.map(item => <li key={item}><code>{item}</code></li>)}</ul>
                </>
              )}
              {idea.done && (
                <>
                  <h3>Zrobione</h3>
                  <ul>{idea.done.map(item => <li key={item}>{item}</li>)}</ul>
                </>
              )}
              {idea.questions.length > 0 && (
                <>
                  <h3>Do potwierdzenia</h3>
                  <ul>{idea.questions.map(item => <li key={item}>{item}</li>)}</ul>
                </>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
